import { WORKFLOW_RUN_COMPLETION_ASK_ID_PREFIX } from '@digital-twins/shared-types'

/** Declared in shared-types, written by the backend completion lane. */
export { WORKFLOW_RUN_COMPLETION_ASK_ID_PREFIX }

export function isWorkflowRunCompletionAskId(
  askId: string | null | undefined,
): boolean {
  return Boolean(
    askId && askId.startsWith(WORKFLOW_RUN_COMPLETION_ASK_ID_PREFIX),
  )
}

/**
 * Pulls `<runToken>` out of `workflow-run-complete:<runToken>` (Step 1c-ii,
 * thread-output-continuity). Null for anything that is not a completion
 * askId, or whose token half is empty/whitespace-only — a malformed id must
 * never resolve to a truthy-looking empty string a caller could fetch with.
 */
export function runTokenFromWorkflowRunCompletionAskId(
  askId: string | null | undefined,
): string | null {
  if (!isWorkflowRunCompletionAskId(askId)) {
    return null
  }
  const token = (askId as string)
    .slice(WORKFLOW_RUN_COMPLETION_ASK_ID_PREFIX.length)
    .trim()
  return token.length > 0 ? token : null
}
